// extracted by mini-css-extract-plugin
module.exports = {"container":"d_c","tiles":"d_h","tile":"d_j","photo":"d_k","text":"d_l"};